// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sound-control {
  position: absolute;
  z-index: -5;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin-top: -1em;
}
.hide-selection {
  -webkit-tap-highlight-color: transparent;
}
.sound-icon-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.sound-icon {
  position: fixed;
  z-index: 1 !important;
  bottom: 5px;
  right: 1px;
  transform: scale(0.4);
}
.music_icon {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 50% !important;
  width: 30px !important;
  height: 30px !important;
  padding: 10px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  position: absolute;
  top: 10px;
  right: 10px;
}
@media (max-width: 420px) {
  .sound-icon-img {
    /* width: 100px;
    height: 19px; */
    object-fit: contain;
  }

  .sound-icon {
    position: fixed;
    bottom: 75px;
    right: 30px;
  }
}
@media only screen and (min-width: 421px) and (max-width: 740px) {
  .sound-icon-img {
    /* width: 60px;
    height: 19px; */
    object-fit: contain;
  }

  .sound-icon {
    position: fixed;
    bottom: 75px;
    right: 30px;
  }
}
@media only screen and (min-width: 741px) and (max-width: 770px) {
  .sound-icon-img {
    /* width: 80px;
    height: 19px; */
    object-fit: contain;
  }

  .sound-icon {
    position: fixed;
    bottom: 75px;
    right: 30px;
  }
}
@media only screen and (min-width: 771px) and (max-width: 950px) {
  .sound-icon-img {
    /* width: 120px;
    height: 24px; */
    object-fit: contain;
  }

  .sound-icon {
    position: fixed;
    bottom: 75px;
    right: 30px;
  }
}
@media only screen and (min-width: 951px) and (max-width: 1258px) {
  .sound-icon-img {
    /* width: 130px;
    height: 28px; */
    object-fit: contain;
  }

  .sound-icon {
    position: fixed;
    bottom: 75px;
    right: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/enviroments/gabar/ui/Audio/sound.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE;IACE;mBACe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE;IACE;mBACe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE;IACE;mBACe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE;IACE;mBACe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE;IACE;mBACe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;EACb;AACF","sourcesContent":[".sound-control {\n  position: absolute;\n  z-index: -5;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin-top: -1em;\n}\n.hide-selection {\n  -webkit-tap-highlight-color: transparent;\n}\n.sound-icon-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.sound-icon {\n  position: fixed;\n  z-index: 1 !important;\n  bottom: 5px;\n  right: 1px;\n  transform: scale(0.4);\n}\n.music_icon {\n  background: rgba(255, 255, 255, 0.5);\n  border-radius: 50% !important;\n  width: 30px !important;\n  height: 30px !important;\n  padding: 10px !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n@media (max-width: 420px) {\n  .sound-icon-img {\n    /* width: 100px;\n    height: 19px; */\n    object-fit: contain;\n  }\n\n  .sound-icon {\n    position: fixed;\n    bottom: 75px;\n    right: 30px;\n  }\n}\n@media only screen and (min-width: 421px) and (max-width: 740px) {\n  .sound-icon-img {\n    /* width: 60px;\n    height: 19px; */\n    object-fit: contain;\n  }\n\n  .sound-icon {\n    position: fixed;\n    bottom: 75px;\n    right: 30px;\n  }\n}\n@media only screen and (min-width: 741px) and (max-width: 770px) {\n  .sound-icon-img {\n    /* width: 80px;\n    height: 19px; */\n    object-fit: contain;\n  }\n\n  .sound-icon {\n    position: fixed;\n    bottom: 75px;\n    right: 30px;\n  }\n}\n@media only screen and (min-width: 771px) and (max-width: 950px) {\n  .sound-icon-img {\n    /* width: 120px;\n    height: 24px; */\n    object-fit: contain;\n  }\n\n  .sound-icon {\n    position: fixed;\n    bottom: 75px;\n    right: 30px;\n  }\n}\n@media only screen and (min-width: 951px) and (max-width: 1258px) {\n  .sound-icon-img {\n    /* width: 130px;\n    height: 28px; */\n    object-fit: contain;\n  }\n\n  .sound-icon {\n    position: fixed;\n    bottom: 75px;\n    right: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
